


























































































































import { Vue, Component, Prop, Watch, Mixins, Ref } from 'vue-property-decorator';
import { Grid } from '@toast-ui/vue-grid';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import GridLayoutsPopup from '@/components/tuigrid/GridLayoutsPopup.vue';
import { i18nAllObject, i18nInObjectList } from '@/utils/i18n';
import { changeDateFormat } from '@/utils/dateUtils';
import { writeExcel, callbackAfterToJson } from '@/utils/excel';
import { PutOrderOptionChangeStatusRequest, PutShippingsAssignInvoicesRequest } from 'supporter';
import { getDownToday } from '@/utils/dateUtils';
import OrderGridsColumns from '@/components/common/order/mixins/OrderGridsColums';
import $ from 'jquery';
import { ncpPopup } from '@/utils/commonUtils';
import { getCookie } from '@/utils/cookieUtils';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';

interface PageObj {
  page: number;
}

interface GridLayoutDataItem {
  columnName: string;
  visible: boolean;
  displayOrder: number;
}

@Component({
  components: { CompSelectBox, ExcelCreateButton },
})
export default class ItemTable extends Mixins(OrderGridsColumns) {
  @Prop({ default: null })
  private readonly onItemClicked: (gridProp) => void;

	@Prop({ default: null })
	private readonly onRowChecked: (gridProp) => void;

	private configOption: any[];
  public getGridLayouts: any = [];
  public parentProps: any = this.$parent;
  public label = this.$route.name;

  onClickConfig(): void {
    let LayerPop = Vue.extend(GridLayoutsPopup);
    let label = this.$route.name;

    if (label === 'DeliveryPrepare') {
      if (getCookie('orderDeliveryPrepareTab') === 'false') {
        label = 'DeliveryPrepare2';
      }
    }
    let pop = new LayerPop({
      propsData: {
        configOption: this.configOption,
        listColumns: this.listColumns,
        label: label,
      },
      model: {
        prop: 'configOption',
        event: 'configOption',
      },
    });
    pop.$t = window.$t;
    this.$eventBus.$emit('LAYER-POP-OPEN', pop);
  }

  @Prop() private option?: any;
  private initOver = false;
  private itemInfo = {
    name: 'grid',
    autoHeight: false,
    nonDataBodyHeight: 190,
    haveDataBodyHeight: 480,
    haveRigthBtn: true,
    haveConfigBtn: true,
    havePageSizeBtn: true,
    haveExcelDownBtn: true,
    noBorder: false,
    onLoadSearch: true,
    excelDownInfo: null as any,
    pageSize: '30',
    pageSizes: [
      { value: '30', name: 'COMMON_PAGE_SIZE_30' },
      { value: '50', name: 'COMMON_PAGE_SIZE_50' },
      { value: '100', name: 'COMMON_PAGE_SIZE_100' },
      { value: '200', name: 'COMMON_PAGE_SIZE_200' },
    ],
  };
  private afterCall: boolean = false;

  @Prop({ required: true })
  public gridProps!: any;

  @Prop({ required: true })
  public listColumns!: any;

  @Prop({ required: true })
  public request!: any;

  @Prop({ required: true, default: () => [] })
  private readonly data!: [];

  @Prop({ default: 0 })
  private totalCount!: number;

  @Prop({ default: false, required: false })
  private showHeader?: boolean;

  @Prop({ required: false })
  private invoiceExcel?: any;

  @Prop({ default: false, required: false })
  private showFooterItem?: boolean;

  @Prop({ required: false, default: (): any => [] })
  public deliveryCompanyTypeArr?: any;

  @Prop({ default: 'COMMON_VIEWRESULTS', required: false })
  private tableTitle?: any;

  @Prop({ default: '', required: false })
  private orderStatusType?: any;

  private pageSize = '30';

  private fileName: string = '';

  private releaseYn: string = 'N';

  public resultExcel: any = {
    columns: {
      shippingNo: 'ORDER_DELIVERY_PREPARE_RESULT_SHIPPING_NO',
      receiverName: 'ORDER_DELIVERY_PREPARE_RESULT_RECEIVER_NAME',
      receiverContact1: 'ORDER_DELIVERY_PREPARE_RESULT_RECEIVER_CONTACT1',
      receiverZipCd: 'ORDER_DELIVERY_PREPARE_RESULT_RECEIVER_ZIP_CD',
      address: 'ORDER_DELIVERY_PREPARE_RESULT_ADDRESS',
      customsIdNumber: 'ORDER_DELIVERY_PREPARE_RESULT_CUSTOMS_ID_NUMBER',
      deliveryTypeLabel: 'ORDER_DELIVERY_PREPARE_RESULT_DEVELIVERY_TYPE_LABEL',
      invoiceNo: 'ORDER_DELIVERY_PREPARE_RESULT_INVOICE_NO',
      orderYmdt: 'ORDER_DELIVERY_PREPARE_RESULT_ORDER_YMDT',
      orderNo: 'ORDER_DELIVERY_PREPARE_RESULT_ORDER_NO',
      ordererName: 'ORDER_DELIVERY_PREPARE_RESULT_ORDER_NAME',
      productName: 'ORDER_DELIVERY_PREPARE_RESULT_PRODUCT_NAME',
      successYn: 'ORDER_DELIVERY_PREPARE_RESULT_SUCCESS_YN',
      failReason: 'ORDER_DELIVERY_PREPARE_RESULT_FAIL_REASON',
    },
    formatters: {
      successYn: (data: any): any => {
        if (data.value === 'Y') {
          return `${window.$t('ORDER_DELIVERY_PREPARE_RESULT_SUCCESS_Y')}`;
        } else {
          return `${window.$t('ORDER_DELIVERY_PREPARE_RESULT_SUCCESS_N')}`;
        }
      },
    },
    fileName: 'result',
  };
  private deliveryCompanyType: any = {
    value: undefined,
  };
  private theInvoiceExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {},
  };

  private changePageSize() {
    this.$nextTick((): void => {
      this.parentProps.search(1, this.itemInfo.pageSize);
    });
  }

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination') as any;
    if (!this.itemInfo.autoHeight) {
      grid.invoke(
        'setBodyHeight',
        this.data.length === 0 ? this.itemInfo.nonDataBodyHeight : this.itemInfo.haveDataBodyHeight,
      );
    }
    if (pagination) {
      const pageState = {
        totalCount: this.totalCount,
        page: this.gridProps.options.pageOptions.page,
        perPage: this.gridProps.options.pageOptions.perPage - 0,
      };
      grid.invoke('resetData', this.data as any, { pageState });
    } else {
      grid.invoke('resetData', this.data as any);
    }
  }

  private excelDown() {
    if (this.totalCount >= 10000) {
      alert(this.$t('ORDER_LIST_GRIDS_EXCELDOWN_TOTAL'));
    }
    if (this.orderStatusType === 'PAY_DONE') {
      if (!confirm(this.$t('ORDER_LIST_GRIDS_PAY_DONE_EXCEL_CONFIRM') as string)) {
        return;
      }
      this.$emit('excelChangeStatus');
    }
    if (this.data && this.data.length > 0) {
      let columns = i18nAllObject(this, this.itemInfo.excelDownInfo.columns);
      let fileName = this.itemInfo.excelDownInfo.fileName;
      if (this.itemInfo.excelDownInfo.nameDateFormat !== undefined) {
        fileName += changeDateFormat(new Date(), this.itemInfo.excelDownInfo.nameDateFormat);
      }
      this.request.params.size = 10000;
      this.request.params.orderNos = null;
      $('#loading').show();
      this.$api
        .getOrderOptionsExcel(this.request)
        .then((res: any) => {
          writeExcel(res.data, columns, fileName, this.itemInfo.excelDownInfo.formatters);
        })
        .finally(() => {
          $('#loading').hide();
        });
    } else {
      alert(this.$t('COMMON_NOT_DATA'));
    }
  }

  private gridFunction(functionKey: any, params?: any) {
    if (params) {
      return (this.$refs.tuiGrid as Grid).invoke(functionKey, ...params);
    } else {
      return (this.$refs.tuiGrid as Grid).invoke(functionKey);
    }
  }

  private async initOption() {
    await this.fetchGridColumns();
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.configOption = this.gridProps.columns.map(d => ({
      name: d.name,
      order: d.order,
      visible: d.visible,
      displayName: d.header,
      disabled: this.getDisabled(d.name),
    }));
    if (this.option) {
      Object.assign(this.itemInfo, this.option);
    }
    this.initOver = true;
    this.parentProps.initExcelColums();
    // this.parentProps.search();
  }

  private async fetchGridColumns() {
    await this.getGridDataLayer(({ data }: any) => {
      // data : 서버 사이드에 저장되어 있는 컬럼 데이터들
      // defaultColumnNames : 클라이언트 사이드에 있는 디폴트 컬럼 종류들
      const defaultColumnNames: string[] = this.listColumns.map(column => this.getColumnName(column));

      const defaultColumnsData = defaultColumnNames.map((defaultColumnName, idx) => ({
        columnName: defaultColumnName,
        displayOrder: idx + 1,
      }))

      const mergedColumnsData = defaultColumnsData.map(({columnName, displayOrder}) => {
        const intersectionItem = data.find((dataItem: GridLayoutDataItem) => dataItem.columnName === columnName);
        const defaultVisible = !['orderOptionNo', 'imageUrl'].includes(columnName);
        const savedVisible = intersectionItem ? intersectionItem.visible : defaultVisible;

       return {
            columnName,
            visible: savedVisible,
            displayOrder: intersectionItem ? intersectionItem.displayOrder: displayOrder,
          }
      });

      this.getGridLayouts = mergedColumnsData.sort((a, b) => a.displayOrder - b.displayOrder).map(({columnName, visible, displayOrder}) => {

        return this.getGridRefactory(columnName, visible, displayOrder)
      })
      this.gridProps.columns = this.getGridLayouts;
    });
  }

  public getColumnName(i18n: string) {
    const foundColumn = this.defaultDisplay.find((item) => item.i18n === i18n);

    return foundColumn?.columnName;
  }

  public setTheValue(rowKey: any, columnName: any, value: any): any {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('setValue', rowKey, columnName, value);
  }
  public getRowItems(rowKey: any): any {
    const grid = this.$refs.tuiGrid as Grid;
    const item: any = grid.invoke('getRow', rowKey);
    return item;
  }
  private getElement(rowKey: any, columnName: any): any {
    const grid = this.$refs.tuiGrid as Grid;
    const element = grid.invoke('getElement', rowKey, columnName);
    return element;
  }
  private getValue(rowKey: any, columnName: any): any {
    const grid = this.$refs.tuiGrid as Grid;
    let value: any = grid.invoke('getValue', rowKey, columnName);
    return value;
  }
  public check(rowKey: any): void {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('check', rowKey);
  }
  public uncheck(rowKey: any): void {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('uncheck', rowKey);
  }
  private resetData(data: any, options?: any): void {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('resetData', data, options);
  }
  private addRowClassName(rowKey: any, className: any): void {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('addRowClassName', rowKey, className);
  }
  private addCellClassName(rowKey, columnName, className) {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('addCellClassName', rowKey, columnName, className);
  }
  private getRowCount(): any {
    const grid = this.$refs.tuiGrid as Grid;
    const count = grid.invoke('getRowCount');
    return count;
  }
  public getCheckedItems(arr: any): any {
    const grid = this.$refs.tuiGrid as Grid;
    const items = grid.invoke('getCheckedRows').map((item: any): any => {
      let theItem: any = {};
      if (arr.length > 0) {
        arr.forEach((key: any): any => {
          theItem[key] = item[key];
        });
      }
      return theItem;
    });
    return items;
  }

  private handleUpload(): void {
    $('#invoiceFile').click();
  }
  private handleUploadBtn(): void {
    const fileName = $('#invoiceFile').val();
    if (fileName === '') {
      alert(this.$t('ORDER_DELIVERY_PREPARE_EXCEL_FILE_NAME_EMPTY_ALERT'));
      return;
    }

    if (!(fileName as any).includes('xls')) {
      alert(this.$t('ORDER_DELIVERY_PREPARE_EXCEL_FILE_NAME_INCLUDES_XLS_ALERT'));
      return;
    }

    if (this.deliveryCompanyType.value === undefined) {
      alert(this.$t('ORDER_DELIVERY_PREPARE_EXCEL_DELIVERY_COMPANY_TYPE_EMPTY_ALERT'));
      return;
    }
    if (confirm(this.$t('ORDER_DELIVERY_PREPARE_CONFIRM_UPLOAD_EXCEL') as string)) {
      const dn = this.$t('ORDER_LIST_GRIDS_HEADER_DELIVER_NO');
      const rn = this.$t('ORDER_LIST_GRIDS_HEADER_RECEIVER_NAME');
      const rc = this.$t('ORDER_LIST_GRIDS_HEADER_RECEIVER_CONTACT1');
      const rzc = this.$t('ORDER_LIST_GRIDS_HEADER_RECEIVER_ZIP_CD');
      const d = this.$t('ORDER_LIST_GRIDS_HEADER_ADRESS');
      const cin = this.$t('ORDER_LIST_GRIDS_HEADER_CUSTOMS_ID_NUMBER');
      const dtl = this.$t('ORDER_LIST_GRIDS_HEADER_DELIVER_TYPE');
      const iN = this.$t('ORDER_LIST_GRIDS_HEADER_INVOICE_NO');
      const oYmdt = this.$t('ORDER_LIST_GRIDS_HEADER_ORDER_YMDT');
      const on = this.$t('ORDER_LIST_GRIDS_HEADER_ORDER_NO');
      const oName = this.$t('ORDER_LIST_GRIDS_HEADER_ORDER_NAME');
      const pn = this.$t('ORDER_LIST_GRIDS_HEADER_PRODUCT_NAME');
      let keyMapJson: any = {};
      this.$set(keyMapJson, dn as any, 'shippingNo');
      this.$set(keyMapJson, rn as any, 'receiverName');
      this.$set(keyMapJson, rc as any, 'receiverContact1');
      this.$set(keyMapJson, rzc as any, 'receiverZipCd');
      this.$set(keyMapJson, d as any, 'address');
      this.$set(keyMapJson, cin as any, 'customsIdNumber');
      this.$set(keyMapJson, dtl as any, 'deliveryTypeLabel');
      this.$set(keyMapJson, iN as any, 'invoiceNo');
      this.$set(keyMapJson, oYmdt as any, 'orderYmdt');
      this.$set(keyMapJson, on as any, 'orderNo');
      this.$set(keyMapJson, oName as any, 'ordererName');
      this.$set(keyMapJson, pn as any, 'productName');

      callbackAfterToJson('invoiceFile', keyMapJson, $.proxy(this.uploadInvoiceCallback, this));
    }
  }
  private uploadInvoiceCallback(jsonData: any): any {
    const excelArrays = [];

    const DATE_REGEX = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})$/;
    let errorFlag = false;
    jsonData.forEach((o: any): any => {
      if (o.shippingNo) {
        if (isNaN(o.shippingNo)) {
          alert(this.$t('ORDER_DELIVERY_PREPARE_NOT_USEFULL_EXCEL'));
          return;
        }
        excelArrays.push(parseInt(o.shippingNo));
      }
      if (DATE_REGEX.exec(o.orderYmdt) === null) {
        errorFlag = true;
      }
    });
    if (excelArrays.length === 0) {
      alert(this.$t('ORDER_DELIVERY_PREPARE_NOT_USEFULL_EXCEL'));
      return;
    }
    if (errorFlag) {
      alert(this.$t('ORDER_DELIVERY_PREPARE_EXCEL_TIME_FORM_ERROR'));
      return;
    }

    const theDCT = this.deliveryCompanyType.value;

    const txt = this.$t('ORDER_DELIVERY_PREPARE_BTN_UPLOADING_TXT');
    this.toggleInvoiceBtn(true, txt);

    let theOption = jsonData.map((item: any): any => {
      return { shippingNo: item.shippingNo, deliveryCompanyType: theDCT, invoiceNo: item.invoiceNo };
    });
    let request: PutShippingsAssignInvoicesRequest = {
      data: {
        requestChannelType: 'PARTNER',
        invoices: theOption,
        releaseYn: this.releaseYn,
      },
    };
    $('#loading').show();
    this.$api
      .putShippingsAssignInvoices(request)
      .then(res => {
        let columns = i18nAllObject(this, this.resultExcel.columns);
        jsonData.map((item: any, index: any): any => {
          item.failReason = res.data[index].failReason;
          item.invoiceNo = res.data[index].invoiceNo;
          item.successYn = res.data[index].successYn;
          item.deliveryCompanyType = res.data[index].deliveryCompanyType;
        });
        writeExcel(jsonData, columns, this.resultExcel.fileName + '_' + getDownToday(), this.resultExcel.formatters);
      })
      .finally((): any => {
        const txt = this.$t('ORDER_LIST_GRIDS_FOOT_UPLOAD_FILE');
        this.toggleInvoiceBtn(false, txt);
        this.clearExcelFile();
        this.afterUpSearch();
        $('#loading').hide();
      });
  }
  private afterUpSearch(): void {
    const pagination = (this.$refs.tuiGrid as Grid).invoke('getPagination') as any;
    this.$emit('searchBtnClick', pagination._currentPage);
  }
  private clearExcelFile(): void {
    this.deliveryCompanyType.value = undefined;
    $('#invoiceFile').val('');
    this.fileName = '';
  }
  private toggleInvoiceBtn(flag: any, msg: any) {
    $('#upload_btn').text(msg);
    $('#upload_btn').prop('disabled', flag);
  }
  private handleFileName(e: any): void {
    if (e.target.files.length > 0) {
      this.fileName = e.target.files[0].name;
    }
  }
  private haldleInvoiceExcel(): void {
    if (this.data && this.data.length > 0) {
      this.initInvoiceExcel();
      let columns = i18nAllObject(this, this.theInvoiceExcelDownIfo.columns);
      writeExcel(
        this.data,
        columns,
        this.theInvoiceExcelDownIfo.fileName + getDownToday(),
        this.theInvoiceExcelDownIfo.formatters,
      );
    } else {
      alert(this.$t('COMMON_NOT_DATA'));
    }
  }
  private initInvoiceExcel(): void {
    this.theInvoiceExcelDownIfo.fileName = 'invoice_';
    this.theInvoiceExcelDownIfo.columns = this.invoiceExcel.columns;
    this.theInvoiceExcelDownIfo.formatters = this.invoiceExcel.formatters;
  }

  public getCheckedRowKeys(): any {
    const grid = this.$refs.tuiGrid as Grid;
    const rowKeys = grid.invoke('getCheckedRowKeys');
    return rowKeys;
  }

  public getCheckedRows(): any {
    const grid = this.$refs.tuiGrid as Grid;
    const rows = grid.invoke('getCheckedRows');
    return rows;
  }

  private handleTaskMessageBtn(e: any): void {
    e.preventDefault();
    const orderNo = $(e.target).data('orderNo');
    ncpPopup(`/order/productOptionDetailPopup?orderNo=${orderNo}`, '', 1280, 1162);
  }
  private changeStatusBtnClick(e: any): void {
    if (!confirm(this.$t('ORDER_LIST_GRIDS_CHANGE_STATUS_CONFIRM') as string)) {
      return;
    }
    let theOption: any[] = [];
    let no: any = $(e.target).attr('orderProductOptionNo');
    const targetStatusType = $(e.target).attr('to');
    theOption.push(this.getRowItems(Number(no)));
    let requestOp: any = theOption.map((item: any) => {
      return {
        deliveryCompanyType: item.deliveryCompanyType,
        invoiceNo: item.invoiceNo,
        mallNo: item.mallNo,
        orderOptionNo: item.orderProductOptionNo,
      };
    });
    let request: PutOrderOptionChangeStatusRequest = {
      data: {
        orderStatusType: 'DELIVERY_PREPARE',
        options: requestOp,
      },
    };
    this.changeStatusProcs(targetStatusType, theOption, false, this.$refs.gridBottom, 'PRODUCT_PREPARE', request);
  }
  private changeStatusProcs(
    targetStatusType: any,
    checkedRowList: any,
    successAlert: any,
    grid: any,
    orderStatusType: any,
    request: any,
  ): any {
    if (targetStatusType === 'DELIVERY_ING') {
      let hasInvoiceInfos = true;
      $.each(checkedRowList, (index, value): any => {
        if (!value.deliveryCompanyType) {
          value.deliveryCompanyType = $((grid as any).getElement(value.rowKey, 'deliveryCompanyType'))
            .find('select')
            .val();
        }
        if (
          value.deliveryType === 'PARCEL_DELIVERY' &&
          value.delivery === true &&
          (value.deliveryCompanyType === null || value.invoiceNo === null)
        ) {
          hasInvoiceInfos = false;
        }
      });
      if (!hasInvoiceInfos) {
        alert(this.$t('ORDER_LIST_GRIDS_INVOICE_NO_EMPTY_ALERT'));
        return;
      }
    }
    const flag = checkedRowList
      .map((row: any): any => {
        return row.taskMessage;
      })
      .every((value: any): any => {
        return value === false;
      });
    if (orderStatusType === 'PRODUCT_PREPARE' || orderStatusType === 'DELIVERY_PREPARE') {
      let message = '';
      switch (targetStatusType) {
        case 'DELIVERY_PREPARE':
          message = this.$t('ORDER_LIST_GRIDS_MESSAGE_CONFIRM_1') as any;
          break;
        case 'PAY_DONE':
          message = this.$t('ORDER_LIST_GRIDS_MESSAGE_CONFIRM_2') as any;
          break;
        case 'DELIVERY_ING':
          message = this.$t('ORDER_LIST_GRIDS_MESSAGE_CONFIRM_3') as any;
          break;
        case 'PRODUCT_PREPARE':
          message = this.$t('ORDER_LIST_GRIDS_MESSAGE_CONFIRM_4') as any;
          break;
        default:
          break;
      }
      if (!flag && !confirm(message)) {
        return;
      }
    }
    this.$api.putOrderOptionChangeStatus(request).then((): any => {
      if (successAlert) {
        alert(this.$t('ORDER_LIST_GRIDS_HANDLE_DONE'));
      }
      this.parentProps.search(1, this.size);
    });
  }

  @Ref('tuiGrid')
  private readonly gridRef: Grid;
  private async mounted() {
    await this.initOption();
    const grid = this.$refs.tuiGrid as Grid;

    this.bindGridEvent();

    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (event: any) => {
        this.$emit('resetData', event.page);
        event.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });

    if (this.itemInfo.onLoadSearch) {
      this.$emit('resetData', 1);
    }

    this.$eventBus.$on('UPDATE-COLUMN-CONFIG', this.onUpdateColumnConfig);
  }

	private invokeRowChecked(checkType: string, selected, gridProps) {
		this.onRowChecked && this.onRowChecked({ checkType: checkType, selected: selected, ...gridProps });
	}

	private bindGridEvent() {
	  // check 관련 이벤트를 proxy
	  this.gridRef.invoke('on', 'check', gridEvent => {
		  this.invokeRowChecked('check', this.getCheckedRowKeys(), gridEvent);
	  });
	  this.gridRef.invoke('on', 'uncheck', gridEvent => {
		  this.invokeRowChecked('uncheck', this.getCheckedRowKeys(), gridEvent);
	  });
	  this.gridRef.invoke('on', 'checkAll', gridEvent => {
		  this.invokeRowChecked('checkAll', this.getCheckedRowKeys(), gridEvent);
	  });
	  this.gridRef.invoke('on', 'uncheckAll', gridEvent => {
		  this.invokeRowChecked('uncheckAll', this.getCheckedRowKeys(), gridEvent);
	  });

	  // check 시 클릭 이벤트 발동 안되도록
    this.gridRef.invoke('on', 'click', (gridProp) => {
      if ((gridProp as any).columnName !== '_checked') {
        this.onItemClicked && this.onItemClicked(gridProp);
      }
    });
  }

  destroyed() {
    this.$eventBus.$off('UPDATE-COLUMN-CONFIG', this.onUpdateColumnConfig);
  }

  async onUpdateColumnConfig() {
    this.getGridLayouts = [];
    const grid = this.$refs.tuiGrid as Grid;
    await this.fetchGridColumns();
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.configOption = this.gridProps.columns.map(d => ({
      name: d.name,
      order: d.order,
      visible: d.visible,
      displayName: d.header,
      disabled: this.getDisabled(d.name),
    }));
    this.parentProps.initExcelColums();
    grid.invoke('setColumns', this.gridProps.columns as any);
  }
}
